module.exports = __webpack_public_path__ + "static/media/8.0dc403fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_41/images/悬浮窗/8.png
// module id = 979
// module chunks = 0